import React, { useEffect, useState } from "react";
import {
  View,
  Modal,
  TouchableOpacity,
  StyleSheet,Image,Linking
} from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from 'rn-responsive-styles'
import CImage from "../../common/CImage";


const ImagePopup = () => {


const styles = useStyles();

const [isImagePopup, setIsImagePopup] = useState(false);




const onCloseModal = async()=>{
    setIsImagePopup(false)
}



  return (
    <Modal
      animationType={"fade"}
      visible={isImagePopup}
      transparent={true}
    >
     <TouchableOpacity style={styles.overlayContainer} >
        <View style={styles.overlay}></View>
       
        <View style={styles.modalContainer}>
          <View style={styles.modalBody}>
            <TouchableOpacity style={styles.closeBtnWidget} onPress={() => onCloseModal()}>
              <CImage.CloseIcon1></CImage.CloseIcon1>
            </TouchableOpacity>
               <Image
                resizeMode="contain"
                style={styles.imageStyle}
                source={{ uri: `data:image/png;base64,${ props?.imageUrl}` }}
              /> 
           
           
          </View>
          
        </View>
        </TouchableOpacity>
      
    </Modal>
  );
};

export default ImagePopup;

const useStyles = CreateResponsiveStyle(
  {
    overlayContainer: {
      height: "100%",
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
    },
    overlay: {
      backgroundColor: "rgba(0,0,0,0.7)",
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,
      zIndex: 99,
    },
    modalContainer: {
      height: "100%",
      width: "100%",
      position: "absolute",
      alignItems: "center",
      justifyContent: "center",
      zIndex:999
    },
    modalBody: {
      width: "90%",
      height: "100%",
      alignSelf: "center",
      borderRadius: 10,
      alignItems: "center",
      justifyContent: "center"
    },
    imageStyle:{ 
      width: 450,
      height: 450, 
      borderRadius: 10, 
      margin: 0, 
      padding: 0,
      alignSelf:'center',
      // marginTop:'-10%'
    },
    btnWidget:{
      width:400,
      marginTop:15,
      height:40
    },
    closeBtnWidget:{
      marginLeft:455
    }
   
   
  },

  {
    [DEVICE_SIZES.LG]: {
      

    },
    [DEVICE_SIZES.MD]: {
      
    },
    [DEVICE_SIZES.SM]: {
      
      imageStyle:{ 
        width: 320,
        height: 320, 
      },
      btnWidget:{
        width:300,
      },
      closeBtnWidget:{
        marginLeft:325
      }
    },
    [DEVICE_SIZES.XS]: {
      btnWidget:{
        width:200,
      },
      imageStyle:{ 
        width: 250,
        height: 250,
      },
      closeBtnWidget:{
        marginLeft:255
      }

    },
  }
);

const styles = StyleSheet.create({
  
});

